import get from 'lodash.get';
import {
  filterTypes,
  FilterConfig,
} from '@app/components/ProductFinder/Filter/types';
import { State } from '@app/components/ProductFinder/Filter/';
import { Condition } from '../../../__generated__/globalTypes';
import { menuOption } from './__generated__/menuOption';

const flattenMenuOptions = (options): menuOption[] => {
  return [
    ...options.map((option) => option.id),
    ...(Array.isArray(options.children)
      ? flattenMenuOptions(options.children)
      : []),
  ];
};

const buildQueryCondition = (
  filters: FilterConfig[],
  state: State
): Condition => {
  return {
    and: filters
      .map((filter) => {
        const value = get(state, filter.id);
        switch (filter.type) {
          case filterTypes.BOOLEAN:
            return value === true // TODO: Make "true" value configurable
              ? { eq: { key: filter.id, value } }
              : null;
          case filterTypes.MULTISELECT:
            return Array.isArray(value) && value.length > 0
              ? { in: { key: filter.id, value } }
              : null;
          case filterTypes.SELECT:
            return Array.isArray(value) && value.length > 0
              ? { eq: { key: filter.id, value: value[0] } }
              : null;
          case filterTypes.MENU: {
            const menuOptions = flattenMenuOptions(
              Array.isArray(value) ? value : []
            );
            return menuOptions.length > 0
              ? // Using typecast to avoid breaking behaviour
                ({ in: { key: filter.id, value } } as Condition)
              : null;
          }
          case filterTypes.RANGE: {
            const min = get(value, 'min');
            const max = get(value, 'max');

            return typeof min === 'number' && typeof max === 'number'
              ? {
                  and: [
                    { gteq: { key: filter.id, value: min } },
                    { lteq: { key: filter.id, value: max } },
                  ],
                }
              : null;
          }
          default:
            return null;
        }
      })
      .filter((condition) => condition !== null),
  };
};

export default buildQueryCondition;
